import _ from 'lodash';
import { Spring } from 'react-spring/renderprops';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

export default class Toggle extends React.Component {
  constructor(props) {
    super(props);
    this.debouncer = _.debounce(this.handleClick.bind(this), props.debounceInterval, {
      leading: true,
      trailing: false,
    });
  }

  render() {
    const { isEnabled, 'data-aid': dataAid } = this.props;
    let translate = isEnabled
      ? `translate(${PILL_WIDTH - CIRCLE_RADIUS * 2 - CIRCLE_MARGIN}px, 0)`
      : `translate(${CIRCLE_MARGIN}px, 0)`;
    return (
      <Pill data-aid={dataAid} isEnabled={isEnabled} onClick={this.debouncer}>
        <Spring to={{ transform: translate }} config={{ tension: 300, friction: 24 }}>
          {props => <Circle style={props} />}
        </Spring>
      </Pill>
    );
  }

  handleClick() {
    this.props.onChange(!this.props.isEnabled);
  }
}

Toggle.propTypes = {
  /** Time (in milliseconds) to delay multiple click interactions (prevents repeated clicking) */
  debounceInterval: PropTypes.number,
  isDisabled: PropTypes.bool,
  isEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  'data-aid': PropTypes.string,
};

Toggle.defaultProps = {
  debounceInterval: 200,
  isDisabled: false,
  isEnabled: false,
};

const CIRCLE_MARGIN = 2;
const CIRCLE_RADIUS = 10;
const PILL_WIDTH = 48;

const pillEnabled = css`
  background-color: ${p => p.theme.colors.green400};
`;

const Pill = styled.div`
  background-color: ${p => p.theme.colors.gray400};
  border-radius: 12px;
  cursor: pointer;
  height: 24px;
  position: relative;
  transition: background-color 300ms ease;
  width: 48px;
  ${p => p.isEnabled && pillEnabled};
`;

const Circle = styled.div`
  background: ${p => p.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.16), 0px 3px 8px rgba(0, 0, 0, 0.15);
  height: ${CIRCLE_RADIUS * 2}px;
  position: absolute;
  top: ${CIRCLE_MARGIN}px;
  width: ${CIRCLE_RADIUS * 2}px;
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/toggle.jsx